import { Outlet, useNavigation } from 'react-router-dom'
import { Progress } from '@components/ui/Progress/Progress'

/**
 * Layout principal de l'application
 * Les routes enfants gèrent leur propre template et header
 * Affiche un indicateur de chargement global pendant les transitions
 */
export function AppLayout() {
  const navigation = useNavigation()
  const isLoading = navigation.state === 'loading'

  return (
    <>
      {isLoading && (
        <div className="fixed top-0 left-0 right-0 z-50">
          <Progress value={undefined} className="h-1" />
        </div>
      )}
      <Outlet />
    </>
  )
}
